// extracted by mini-css-extract-plugin
module.exports = {"waveDistribution":"WaveDistribution_waveDistribution__rr65v","compareMessage":"WaveDistribution_compareMessage__2hdAH"};